import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue'

import InDmChatRow from '@/client/components/_molecules/in_dm_chat_row'

import type { InDmChatItem } from './types'
import { useSequentialPlayback } from './useSequentialPlayback'

interface Props {
  account: {
    pictureUrl: string | null
  }
  chatItems: InDmChatItem[]
  playbackControl: {
    stepIntervalMs: number
    isPlaying: boolean
    isReset?: boolean
  }
}
interface Emits {
  (e: 'update:playbackControl', value: Props['playbackControl']): void
  (e: 'update:visibleCount', value: number): void
}
interface ChatRow {
  item: InDmChatItem
  showAvatar: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InDmChatArea',
  props: {
    account: null,
    chatItems: null,
    playbackControl: null
  },
  emits: ["update:playbackControl", "update:visibleCount"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:playbackControl', value: Props['playbackControl']): void
  (e: 'update:visibleCount', value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  account: {
    pictureUrl: string | null
  }
  chatItems: InDmChatItem[]
  playbackControl: {
    stepIntervalMs: number
    isPlaying: boolean
    isReset?: boolean
  }
};





const isReceiveItem = (item: InDmChatItem): boolean =>
  (item.type === 'message' && item.side === 'left') || item.type === 'media' || item.type === 'card'

const total = computed(() => props.chatItems.length)

const clearResetFlag = () => {
  if (props.playbackControl.isReset) {
    emit('update:playbackControl', { ...props.playbackControl, isReset: false })
  }
}

const scrollContainerRef = ref<HTMLElement | null>(null)

const { visibleCount } = useSequentialPlayback({
  total,
  stepIntervalMs: computed(() => props.playbackControl.stepIntervalMs),
  isPlaying: computed(() => props.playbackControl.isPlaying),
  isReset: computed(() => props.playbackControl.isReset ?? false),
  onComplete: clearResetFlag,
  scrollContainer: scrollContainerRef
})

watch(
  () => props.playbackControl.isPlaying,
  playing => {
    if (!playing) clearResetFlag()
  }
)

watch(visibleCount, count => emit('update:visibleCount', count))

const visibleItems = computed(() => props.chatItems.slice(0, visibleCount.value))
const isEmpty = computed(() => visibleItems.value.length === 0)

const chatRows = computed<ChatRow[]>(() => {
  const items = visibleItems.value
  return items.map((item, index) => {
    if (!isReceiveItem(item)) return { item, showAvatar: false }
    // 次が受信でない（送信/日付/末尾）なら、この受信アイテムがブロック末尾＝アバターを表示する
    const next = items[index + 1]
    const isBlockTail = next === undefined || !isReceiveItem(next)
    return { item, showAvatar: isBlockTail }
  })
})

return { __sfc: true,props, emit, isReceiveItem, total, clearResetFlag, scrollContainerRef, visibleCount, visibleItems, isEmpty, chatRows, InDmChatRow }
}

})